import '@hotwired/turbo-rails'
import './controllers'
import * as ActiveStorage from '@rails/activestorage'
import 'trix'
import './trix_customizations'
import '@rails/actiontext'

ActiveStorage.start()
